import { http } from '@pendo/http';

export function fetchCoreEventGroups () {
    return http.get('api/s/_SID_/coreevents?items=false');
}

export function patchCoreEvents (coreEvents) {
    return http.patch('api/s/_SID_/coreevents', coreEvents);
}

export function fetchCoreEventsEmptyState () {
    return http.get('api/s/_SID_/coreevents/isempty');
}
